import commaNumber from 'comma-number';

import { cn } from '@/lib/cn';

type Props = {
  isPercentage: boolean;
  value: number | null;
  onClick?: () => void;
  totalCell?: boolean;
};

const TableCellRenderer = (props: Props) => {
  const { isPercentage, value, onClick, totalCell } = props;

  // null 값인 경우 '-' 표시 (% 단위 미표시)
  if (value === null || value === undefined) {
    return (
      <div onClick={undefined} className="flex cursor-default font-normal">
        -
      </div>
    );
  }

  return (
    <div
      onClick={totalCell ? undefined : onClick}
      className={cn(
        'flex cursor-pointer font-normal hover:text-primary100 hover:underline',
        totalCell &&
          'font-bold cursor-default hover:text-gray700 hover:no-underline',
      )}
    >
      {isPercentage ? `${value}%` : commaNumber(value)}
    </div>
  );
};

export default TableCellRenderer;
